import {useMutation, useQueryClient} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';
import {useUserDetails} from '@/lib/auth';

import {firmSettingsApi} from '../api';
import {firmSettingsKeys, persistFirmProfile} from './useFirmProfileQuery';

import type {UpdateFirmProfilePayload} from '@sollapay/types';

export function useUpdateFirmProfileMutation() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  const {org} = useUserDetails();

  return useMutation({
    mutationFn: (payload: UpdateFirmProfilePayload) =>
      firmSettingsApi.updateProfile(client, payload),
    onSuccess: response => {
      // The PATCH response already carries the fresh profile — no need to invalidate and
      // trigger a redundant GET /firm/profile round trip for data we already have.
      queryClient.setQueryData(firmSettingsKeys.profile(), response);
      persistFirmProfile(org?.id, response.data);
    }
  });
}
